import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';

/*
 * TODO: 数値は確定値に差し替え可能。現状はサロン向け LP（home/number）と同じ値。
 * 「218」は “求人送付対象校” であって “導入校” ではない。導入校数は別途確定値を受領してから追加する。
 */
const ITEMS = [
  { value: '3,900', unit: '＋', label: '登録店舗' },
  { value: '500', unit: '＋', label: '掲載求人' },
  { value: '46', unit: '', label: '都道府県に求人掲載' },
  { value: '218', unit: '＋', label: '求人送付対象校' },
];

const Numbers = () => {
  return (
    <section className={Styles.numbers}>
      <SectionTitle kicker="Numbers" title="数字で見る memorii works" />

      <div className={Styles.row}>
        {ITEMS.map((it) => (
          <div key={it.label} className={Styles.item}>
            <p className={Styles.value}>{it.value}<span>{it.unit}</span></p>
            <p className={Styles.label}>{it.label}</p>
          </div>
        ))}
      </div>

      <p className={Styles.note}>2026年8月時点</p>
      <p className={Styles.footnote}>
        「求人送付対象校 218校以上」は、サロンが memorii works から求人票を送付できる学校数です（導入校数ではありません）。
      </p>
    </section>
  );
};

export default Numbers;
